export const ETAPAS_ESTEIRA = {
  HOME: 'home',
  AUDITORIA_DOCUMENTAL: 'auditoria_documental',
  PERFORMANCE_DOCUMENTAL: 'performance_documental',
  ANALISE_CADASTRAL: 'analise_cadastral',
  SOCIOS_VINCULOS: 'socios_vinculos',
  ANALISE_FINANCEIRA: 'analise_financeira',
  PARECER_FINAL: 'parecer_final'
};

export const ETAPAS_MVP = [
  ETAPAS_ESTEIRA.HOME,
  ETAPAS_ESTEIRA.AUDITORIA_DOCUMENTAL,
  ETAPAS_ESTEIRA.PERFORMANCE_DOCUMENTAL
];

export const ETAPAS_EM_BREVE = [
  ETAPAS_ESTEIRA.ANALISE_CADASTRAL,
  ETAPAS_ESTEIRA.SOCIOS_VINCULOS,
  ETAPAS_ESTEIRA.ANALISE_FINANCEIRA,
  ETAPAS_ESTEIRA.PARECER_FINAL
];

export const ETAPAS_ESTEIRA_LABELS = {
  [ETAPAS_ESTEIRA.AUDITORIA_DOCUMENTAL]: 'Auditoria Documental',
  [ETAPAS_ESTEIRA.PERFORMANCE_DOCUMENTAL]: 'Performance Documental',
  [ETAPAS_ESTEIRA.ANALISE_CADASTRAL]: 'Análise Cadastral',
  [ETAPAS_ESTEIRA.SOCIOS_VINCULOS]: 'Sócios e Vínculos',
  [ETAPAS_ESTEIRA.ANALISE_FINANCEIRA]: 'Análise Financeira',
  [ETAPAS_ESTEIRA.PARECER_FINAL]: 'Parecer Final'
};
